import store from '@/store';

export default (to, from, next) => {
    const is_number_porting_on_dashboard_allowed = store.getters.is_number_porting_on_dashboard_allowed;

    return {
        allow: is_number_porting_on_dashboard_allowed,
        redirect: { name: 'not-found' },
    }
};
